// Custom JS

window.onload = function() {
  document.querySelector('body').classList.add('body-fade');
};


theme.animateElement = (function() {
	// Animations on scroll start
	const elements = document.querySelectorAll(".custom__item, .animate-img-element, .animate-text-element, .animate-block")

	// fade out on load
	elements.forEach(element => {
	  element.style.opacity = 0.5
	})

	const fadeIn = function () {
	  // look through all the animated tags and see
	  // with the getBoundingClientRect if it's in the window
	  let delay = 0

	  elements.forEach(element => {
	    const positionFromTop = element.getBoundingClientRect().top
	    const positionFromBottom = element.getBoundingClientRect().bottom

	    if (positionFromTop < window.innerHeight && positionFromBottom > 0) {
	      element.style.animation = `fadein 1s ease-in-out ${delay}s both`
	      delay = delay + 0.2
	    }
	  })
	}

	// on load, run fadeIn
	fadeIn();

	// on scroll, run fadeIn
	window.addEventListener("scroll", fadeIn);

	// on browser resize, run fadeIn
	window.addEventListener("resize", fadeIn);
	// Animations on scroll end
})();

theme.animateRow = (function() {
	// Animations on scroll start
	const elements = document.querySelectorAll(".animate-row");

	// fade out on load
	elements.forEach(element => {
	  element.style.opacity = 0.5
	})

	const fadeIn = function () {
	  // look through all the animated tags and see
	  // with the getBoundingClientRect if it's in the window

	  elements.forEach(element => {
	    const positionFromTop = element.getBoundingClientRect().top
	    const positionFromBottom = element.getBoundingClientRect().bottom

	    if (positionFromTop < window.innerHeight && positionFromBottom > 0) {
	      element.style.animation = `fadein 1s both`
	    }
	  })
	}

	// on load, run fadeIn
	fadeIn();

	// on scroll, run fadeIn
	window.addEventListener("scroll", fadeIn);

	// on browser resize, run fadeIn
	window.addEventListener("resize", fadeIn);
	// Animations on scroll end
})();

theme.scrollingHeader = (function() {
	var header = document.querySelector('.site-header__secondary-row');

  if (!header) {return}

	window.addEventListener('scroll', function() {
		var fromTop = window.pageYOffset;
		if (fromTop > 0) {
			header.classList.add("is-scrolling");
		} else {
			header.classList.remove("is-scrolling");
		}
	});
})();

theme.anchorSmoothScroll = (function() {
	const links = document.querySelectorAll("a[href^='#'] ");

	for (const link of links) {
	  link.addEventListener("click", clickHandler);
	}

	function clickHandler(e) {
	  e.preventDefault();
	  const href = this.getAttribute("href");
	  const offsetTop = document.querySelector(href).offsetTop;

	  scroll({
	    top: offsetTop - 170,
	    behavior: "smooth"
	  });
	}
})();

theme.cartTerms = (function() {
  var label = document.querySelector('.terms-msg');

  if(typeof(label) != 'undefined' && label != null){
    label.addEventListener("click", checkInput);
    checkInput();

    function checkInput() {
      var checkbox = document.getElementById('cart-terms'),
          button = document.querySelector('.cart__submit');

      if (checkbox.checked) {
        // Checked
        button.disabled = false;
      } else {
        // Not checked
        button.disabled = true;
      }
    }
  }
})();

theme.drawers = (function() { 
  var toggle = document.querySelectorAll('.open-drawer');

  toggle.forEach(function(el) {    
    var id = el.getAttribute('data-id');
    var drawer = document.getElementById('drawer--' + id);
    var container = document.querySelector("body");

    if(typeof(drawer) != 'undefined' && drawer != null){
      el.addEventListener("click", showDrawer);
      document.querySelectorAll(".close-drawer").forEach(close => { close.addEventListener("click", hideDrawer); });

      function showDrawer() {
        document.querySelectorAll(".drawer").forEach(drawer => { drawer.classList.remove("this-drawer-is-open"); });
        drawer.classList.add("this-drawer-is-open");
        container.classList.add("a-drawer-is-open");
      }
      
      function hideDrawer() {
        drawer.classList.remove("this-drawer-is-open");
        container.classList.remove("a-drawer-is-open");
      }
    }
  });
})();

theme.accordion = (function() {
	function initAcc(elem, option){
    document.addEventListener('click', function (e) {
        if (!e.target.matches(elem+' .accordion-toggle')) return;
        else{
            if(!e.target.parentElement.classList.contains('active')){
                if(option==true){
                    var elementList = document.querySelectorAll(elem+' .accordion__container');
                    Array.prototype.forEach.call(elementList, function (e) {
                        e.classList.remove('active');
                    });
                }
                e.target.parentElement.classList.add('active');
            }else{
                e.target.parentElement.classList.remove('active');
            }
        }
    });
	}

	initAcc('.accordion-wrapper', true);
})();

theme.tableAccordion = (function() {
  document.querySelectorAll('.accordion-table tr td:first-child').forEach(element => element.classList.add('accordion-table-toggle'))
  document.querySelectorAll('.accordion-table tr td:last-child').forEach(element => element.classList.add('accordion-table-panel'))

  var acc = document.getElementsByClassName("accordion-table-toggle");
  var i;

  for (i = 0; i < acc.length; i++) {

    acc[i].addEventListener("click", function(ev) {
      closeAll(ev.target);
      this.classList.toggle("active");
      var panel = this.nextElementSibling;
      if (panel.style.maxHeight) {
        panel.style.maxHeight = null;
      } else {
        panel.style.maxHeight = panel.scrollHeight + "px";
      }
    });
  }

  function closeAll(tar) {
    var accs = document.querySelectorAll('.accordion-table-toggle');
    for (var i = 0; i < accs.length; i++) {
      if (accs[i] == tar) {
        continue;
      }
      accs[i].classList.remove('active');
      var panel = accs[i].nextElementSibling;
      panel.style.maxHeight = null;
    }
  }
})();

theme.productSwatches = (function() {
  function init() {
    var swatch = document.querySelectorAll('.variant-swatch');

    swatch.forEach(function(el) {
      el.addEventListener("click", updateSwatch);

      function updateSwatch() {
        var parent = el.closest(".selector-wrapper");
        var newColor = el.getAttribute('data-id');
        var label = parent.querySelector('.selector-wrapper_name span');

        label.innerHTML = newColor;
      }
    });
  }

  return init();
})();

theme.productQuantity = (function() {
  var prodTemplate = document.querySelectorAll('.template-product');
  
  if(typeof(prodTemplate) != 'undefined' && prodTemplate != null){
    var qtyIncrement = document.querySelectorAll('.js--quantity');

    qtyIncrement.forEach(function(el) { 
      el.addEventListener("click", updateQty);

      function updateQty(el) {
        var parent = this.closest(".quantity-wrapper"),
            input = parent.querySelector('input'),
            inputVal = parseInt(input.value),
            sendQuantity = 0,
            incrementBoolean = this.getAttribute('data-increment'),
            increment = incrementBoolean.toString();

        if (increment == 'true') {
          var newVal = inputVal+1;
          input.value = newVal;
        } else {
          if (inputVal-1 != 0) {
            var newVal = inputVal-1;
            input.value = newVal;
          }
        }   
      }
    });
  }
})();

theme.cookies = (function() {
  function setCookie(cname,cvalue,exdays) {
    const d = new Date();
    d.setTime(d.getTime() + (exdays*24*60*60*1000));
    let expires = "expires=" + d.toGMTString();
    document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
  }

  function getCookie(cname) {
    let name = cname + "=";
    let decodedCookie = decodeURIComponent(document.cookie);
    let ca = decodedCookie.split(';');
    for(let i = 0; i < ca.length; i++) {
      let c = ca[i];
      while (c.charAt(0) == ' ') {
        c = c.substring(1);
      }
      if (c.indexOf(name) == 0) {
        return c.substring(name.length, c.length);
      }
    }
    return "";
  }

  function checkCookie() {
    let cookie = getCookie("generalCookie");
    var cookieModal = document.querySelector('.cookie-banner');
    
    if (typeof(cookieModal) != 'undefined' && cookieModal != null) {
      if (cookie != "") {
        // Returning visitor
        // If the modal doesn't have the class then add class 'hide'.
        if (!cookieModal.classList.contains('hide-modal')) {
          cookieModal.classList.add('hide-modal');
        }
      } else {
        // New visitor
        var closeModal = document.querySelector('.close-banner'); 
        cookie = 'true';
        
        // Show modal
        setTimeout(function(){ 
          cookieModal.classList.remove('hide-modal');
        }, 2000);

        // Close modal and set cookie
        closeModal.addEventListener("click", function(){
          cookieModal.classList.add('hide-modal');

          if (cookie != "" && cookie != null) {
            // Cookie Name, Cookie Value, No of days until expiry
            setCookie("generalCookie", cookie, 1);
          }
        });
      }
    }
  }

  checkCookie();
})();

theme.newsletterModal = (function() {
  function setNewsCookie(cname,cvalue,exdays) {
    const d = new Date();
    d.setTime(d.getTime() + (exdays*24*60*60*1000));
    let expires = "expires=" + d.toGMTString();
    document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
  }

  function getNewsCookie(cname) {
    let name = cname + "=";
    let decodedCookie = decodeURIComponent(document.cookie);
    let ca = decodedCookie.split(';');
    for(let i = 0; i < ca.length; i++) {
      let c = ca[i];
      while (c.charAt(0) == ' ') {
        c = c.substring(1);
      }
      if (c.indexOf(name) == 0) {
        return c.substring(name.length, c.length);
      }
    }
    return "";
  }

  function checkNewsCookie() {
    let newsCookie = getNewsCookie("newsCookie");
    var newsCookieModal = document.querySelector('.pillars-newsletter__popup');
    
    if (typeof(newsCookieModal) != 'undefined' && newsCookieModal != null) {
      if (newsCookie != "") {
        // Returning visitor
        // If the modal doesn't have the class then add class 'hide'.
        if (!newsCookieModal.classList.contains('hide-modal')) {
          newsCookieModal.classList.add('hide-modal');
        }
      } else {
        // New visitor
        var closeModalTriggers = document.querySelectorAll('.close-trigger'); 
        newsCookie = 'true';
        
        // Show modal
        setTimeout(function(){ 
          newsCookieModal.classList.remove('hide-modal');
        }, 8000);

        // Close modal and set cookie
        closeModalTriggers.forEach(element => {
          element.addEventListener("click", function(){
            newsCookieModal.classList.add('hide-modal');

            if (newsCookie != "" && newsCookie != null) {
              // Cookie Name, Cookie Value, No of days until expiry
              setNewsCookie("newsCookie", newsCookie, 1);
            }
          });
        });
      }
    }
  }

  checkNewsCookie();
})();

theme.newsletterTerms = (function() {
  var label = document.querySelector('.accepts-marketing');

  if(typeof(label) != 'undefined' && label != null){
    label.addEventListener("click", checkInput);
    checkInput();

    function checkInput() {
      var checkbox = document.getElementById('accepts_marketing'),
          button = document.querySelector('.newsletter__submit');

      if (checkbox.checked) {
        // Checked
        button.disabled = false;
      } else {
        // Not checked
        button.disabled = true;
      }
    }
  }
})();

theme.redirects = (function() {
  var page1 = document.querySelector('.page-brand-hub');
  var page2 = document.querySelector('.page-tours');


  if(typeof(page1) != 'undefined' && page1 != null){
    var REDIRECT_PATH = '/pages/brand-hub';

    var selector = '#customer_login, form[action$="/account"][method="post"]',
        form = document.querySelectorAll(selector)[0];

    if (form) {
      redirect = document.createElement('input');
      redirect.setAttribute('name', 'return_to');
      redirect.setAttribute('type', 'hidden');
      redirect.value = REDIRECT_PATH;
      form.appendChild(redirect);
    }
  }

  if(typeof(page2) != 'undefined' && page2 != null){
    var REDIRECT_PATH = '/pages/brewery-tours';

    var selector = '#customer_login, form[action$="/account"][method="post"]',
        form = document.querySelectorAll(selector)[0];

    if (form) {
      redirect = document.createElement('input');
      redirect.setAttribute('name', 'return_to');
      redirect.setAttribute('type', 'hidden');
      redirect.value = REDIRECT_PATH;
      form.appendChild(redirect);
    }
  }
})();

theme.customerAccountCheckoutRedirect = (function() {
  var page = document.querySelector('.page-customer-redirect');

  if(typeof(page) != 'undefined' && page != null){
    var REDIRECT_PATH = '/cart';

    var selector = '#customer_login, #create_customer, form[action$="/account"][method="post"]',
        form = document.querySelectorAll(selector)[0];

    if (form) {
      redirect = document.createElement('input');
      redirect.setAttribute('name', 'return_to');
      redirect.setAttribute('type', 'hidden');
      redirect.value = REDIRECT_PATH;
      form.appendChild(redirect);
    }
  }
})();

//
//  Equal height
//
var matchHeight = function () {
  function init() {
    eventListeners();
    matchHeight();
  }
  
  function eventListeners(){
    $(window).on('resize', function() {
      matchHeight();
    });
  }
  
  function matchHeight(){
    var groupName = $('[data-match-height]');
    var groupHeights = [];
    
    groupName.css('min-height', 'auto');
    
    groupName.each(function() {
      groupHeights.push($(this).outerHeight());
    });
    
    var maxHeight = Math.max.apply(null, groupHeights);
    groupName.css('min-height', maxHeight);
  };
  
  return {
    init: init
  };
  
} ();

$(document).ready(function() {
  matchHeight.init();
});

// Karrmoon Start
/**
 * Component: Quick view
 * ------------------------------------------------------------------------------
 * A quick view component.
 *
 */

/**
 * Create a new quick view object.
 */
theme.quickView = (function() {
  /**
   * DOM selectors.
   */
  const selectors = {
    container: '[js-quick-view="container"]',
    mask: '[js-quick-view="mask"]',
    body: '[js-quick-view="body"]',
    toggle: '[js-quick-view="toggle"]',
    close: '[js-quick-view="close"]',
  };

  /**
 * DOM node selectors.
 */
  const nodeSelectors = {
    container: document.querySelector(selectors.container),
    mask: document.querySelector(selectors.mask),
    body: document.querySelector(selectors.body),
    toggle: document.querySelectorAll(selectors.toggle),
  };

  /**
 * Initialise component.
 */
  function init() {
    if (!nodeSelectors.toggle) {return;}

    setEventListeners();
    console.log(`🏅 Quick View: Loaded`)
  }

  /**
 * Set event listeners.
 */
  function setEventListeners() {
    nodeSelectors.toggle.forEach((item) => {
      item.addEventListener("click", function(event){
        const productHandle = event.target.dataset.quickViewUrl;
        handleQuickViewEvent(productHandle)
      });
    });

    document.addEventListener('click', function (event) {
      // All click events will be handled by this function, so it needs to be as cheap as possible. To check
      // whether this function should be invoked, we're going to check whether the element that was clicked on
      // was the elemnt that we care about. The element that was clicked on is made available at "e.target"
      const element = event.target;

      // Check if it matches our previously defined selector
      if (element.matches(selectors.close)) {
        closeQuickAdd();
      }

      if (element.matches(selectors.mask)) {
        closeQuickAdd();
      }
    });
  }

  /**
 * Handle QuickAdd modal close.
 */
  function closeQuickAdd() {
    nodeSelectors.container.classList.remove('is-active');
  }

  /**
 * Handle quick view event.
 * @param {String} handle - The product handle to quick view.
 */
  function handleQuickViewEvent(handle) {
    nodeSelectors.container.classList.add('is-active');
    setLoadingState();
    toggleQuickView(handle);

    //  TODO: look at updating the container to load this in
  }

  /**
 * Toggle quick view modal after fetching data from toggle target.
 * @param {String} handle - The product handle to quick view.
 */
  function toggleQuickView(handle) {

    fetch(getProductUrl(handle))
      .then(res => {
        return res.text();
      })
      .then(data => {
        nodeSelectors.body.innerHTML = data;
        removeLoadingState();

        const container = document.querySelector('.product-template__container');
        const p = new theme.Product(container);
      })
      .then( function() {
        addDynamicListeners(handle)
      })
      .catch((error) => error);
  }

  function addDynamicListeners(handle) {
    const container = document.querySelector('.product-template__container');
    const select = container.querySelectorAll('.single-option-selector');

    select.forEach((item) => {
      item.addEventListener("change", function(event){
        updateImage(handle)
      });
    });
  }

  function updateImage(handle) {
    const select = document.querySelector('.product-form__variants');
    const selectVal = parseInt(select.value);
    const productJson = JSON.parse(document.getElementById('ProductJson-product-quick-view').textContent);
    const variants = productJson.variants;

    variants.forEach((item) => {
      if(item.id === selectVal) {
        if(item.hasOwnProperty('featured_image') != null && item.featured_image != null) {
          if(item.featured_image.hasOwnProperty('src') != null) {
            const imageClass = document.querySelector('.js-image-' + handle);
            imageClass.src = item.featured_image.src;
            imageClass.srcset = item.featured_image.src;
          }
        }
      }

    });
  }

  /**
 * Set loading state.
 */
  function setLoadingState() {
    // If a loading state is needed 🤷‍♀️
    nodeSelectors.body.innerHTML = `<div class="quick-view__loading">Loading</div>`;
    nodeSelectors.body.classList.add('is-loading');
  }

  /**
 * Remove loading state.
 */
  function removeLoadingState() {
    // If a loading state is needed 🤷‍♀️
    nodeSelectors.body.classList.remove('is-loading');
    return;
  }

  /**
 * Get quick view product template url.
 * @param {String} handle - The product handle to quick view.
 * @returns {String}
 */
  function getProductUrl(handle) {
    return `/products/${handle}?view=quick-view`;
  }

  /**
 * Expose public interface.
 */
  return init()
})();


/**
 * Create a main product slider.
 */
theme.productMainSlider = (function() {
  /**
   * Initialise component.
   */
  function init() {
    console.log(`🤖 Product Slider: Loaded`)
    createSwiper();
  }

  function createSwiper() {
    const swiper = new Swiper('.product-main-swiper', {
      slidesPerView: 1,
      effect: "fade",
      loop: true,
      pagination: {
        el: ".swiper-pagination",
        clickable: true,
      },
      navigation: {
        nextEl: ".swiper-button-next--product-main",
        prevEl: ".swiper-button-prev--product-main",
      },
    });
  }

  window.addEventListener('DOMContentLoaded', () => {
    init();
  });

  return init;
})();


/**
 * Component: Module Sixteen Slider
 * ------------------------------------------------------------------------------
 * A Slider component.
 *
 */

/**
 * Create a subcategories slider.
 */
theme.moduleSixteenSlider = (function() {
  /**
   * Initialise component.
   */
  function init() {
    console.log(`🍭 Menu List Overflow Slider: Loaded`)
    const sliders = document.querySelectorAll('.module-sixteen__links');

    sliders.forEach(element => {
      createSwiper(element);
    });
  }

  function createSwiper(element) {
    // const sectionId = element.dataset.sectionId;
    const swiper = new Swiper(`.module-sixteen__links`, {
    // const swiper = new Swiper('.collection-swiper', {
      slidesPerView: "auto",
      spaceBetween: 15,
      loop: false,
      navigation: {
        nextEl: `.swiper-button-next--subcategories`,
        prevEl: `.swiper-button-prev--subcategories`,
      },
    });
  }

  window.addEventListener('DOMContentLoaded', () => {
    init();
  });

  return init;

  function checkOverflow(){
    var header = document.querySelectorAll('.module-sixteen__links');
    var nav = document.querySelectorAll('.module-sixteen__links-container');
    var container = document.querySelector("body");

    if (nav.offsetWidth > header.offsetWidth) {
      container.classList.add("is-overflowing");

      var underlay = document.querySelector(".drawer-page-content");
      var divsToHide = document.getElementsByClassName("meganav");
      var d = document.getElementsByClassName("site-nav__link");

      for(var i = 0; i < divsToHide.length; i++){
        divsToHide[i].classList.remove("is-visible");
      }

      for(var i = 0; i < d.length; i++){
        d[i].classList.remove("active-link");
      }
    } else {
      container.classList.remove("is-overflowing");
      meganav();
    }
  }

  window.addEventListener("load", checkOverflow);
  window.addEventListener("resize", checkOverflow);
})();


/**
 * Component: Pillars Module Nine Slider
 * ------------------------------------------------------------------------------
 * A Slider component.
 *
 */

// TODO: Update images

/**
 * Create a product related slider.
 */
theme.pillarsModuleNineSlider = (function() {
  /**
   * Initialise component.
   */
  function init() {
    console.log(`👸 Pillars Module Nine Slider: Loaded`)
    const sliders = document.querySelectorAll('.pillars-module-nine-swiper');
    
    sliders.forEach(element => {
      createSwiper(element);
    });
  }

  function createSwiper(element) {
    const sectionId = element.dataset.sectionId;
    const swiper = new Swiper('.pillars-module-nine-swiper--' + sectionId, {
      slidesPerView: 1,
      spaceBetween: 0,
      grabCursor: false,
      pagination: {
        el: ".swiper-pagination--" + sectionId,
        clickable: true,
      },
      breakpoints: {
        989: {
          enabled: true,
          slidesPerView: 1,
          centeredSlides: true,
          spaceBetween: 0,
          initialSlide: 1,
          loop: true,
        },
        990: {
          enabled: false,
          slidesPerView: 3,
          spaceBetween: 0,
        }
      },
    });
  }

  window.addEventListener('DOMContentLoaded', () => {
    init();
  });

  return init;
})();


/**
 * Component: Pillars Module Ten Slider
 * ------------------------------------------------------------------------------
 * A Slider component.
 *
 */

// TODO: Update images

/**
 * Create a product related slider.
 */
theme.pillarsModuleTenSlider = (function() {
  /**
   * Initialise component.
   */
  function init() {
    console.log(`👸 Pillars Module Ten Slider: Loaded`)
    const sliders = document.querySelectorAll('.pillars-module-ten-swiper');
    
    sliders.forEach(element => {
      createSwiper(element);
    });
  }

  function createSwiper(element) {
    const sectionId = element.dataset.sectionId;
    const swiper = new Swiper('.pillars-module-ten-swiper--' + sectionId, {
      slidesPerView: 1,
      spaceBetween: 0,
      grabCursor: false,
      pagination: {
        el: ".swiper-pagination--" + sectionId,
        clickable: true,
      },
      breakpoints: {
        989: {
          enabled: true,
          slidesPerView: 1,
          centeredSlides: true,
          spaceBetween: 0,
          initialSlide: 1,
          loop: true,
        },
        990: {
          enabled: false,
          slidesPerView: 2,
          spaceBetween: 0,
        }
      },
    });
  }

  window.addEventListener('DOMContentLoaded', () => {
    init();
  });

  return init;
})();

/**
 * Component: Pillars Module Eight Slider
 * ------------------------------------------------------------------------------
 * A Slider component.
 *
 */

// TODO: Update images

/**
 * Create a product related slider.
 */
theme.pillarsModuleEightSlider = (function() {
  /**
   * Initialise component.
   */
  function init() {
    console.log(`👸 Pillars Module Eight Slider: Loaded`)
    const sliders = document.querySelectorAll('.pillars-module-eight-swiper');
    
    sliders.forEach(element => {
      createSwiper(element);
    });
  }

  function createSwiper(element) {   
    const sectionId = element.dataset.sectionId;
    const swiper = new Swiper('.pillars-module-eight-swiper--' + sectionId , {
      slidesPerView: 1,
      spaceBetween: 0,
      grabCursor: false,
      //freeMode: true,
      keyboard: {
        enabled: true,
      },
      pagination: {
        el: ".swiper-pagination--" + sectionId,
        clickable: true,
      },
      breakpoints: {
        989: {
          enabled: true,
          slidesPerView: 1,
          spaceBetween: 0,
          initialSlide: 1,
          loop: true,
        },
        990: {
          enabled: false,
          slidesPerView: 3,
          spaceBetween: 0,
        }
      },
    });
  }

  window.addEventListener('DOMContentLoaded', () => {
    init();
  });

  return init;
})();

/**
 * Component: Pillars Module Eleven Slider
 * ------------------------------------------------------------------------------
 * A Slider component.
 *
 */

// TODO: Update images

/**
 * Create a product related slider.
 */
theme.pillarsModuleElevenSlider = (function() {
  /**
   * Initialise component.
   */
  function init() {
    console.log(`👸 Pillars Module Eleven Slider: Loaded`)
    const sliders = document.querySelectorAll('.pillars-module-eleven-swiper');
    
    sliders.forEach(element => {
      createSwiper(element);
    });
  }

  function createSwiper(element) {
    const sectionId = element.dataset.sectionId;
    const swiper = new Swiper('.pillars-module-eleven-swiper--' + sectionId, {
      slidesPerView: 1,
      spaceBetween: 0,
      grabCursor: false,
      pagination: {
        el: ".swiper-pagination--" + sectionId,
        clickable: true,
      },
      breakpoints: {
        989: {
          enabled: true,
          slidesPerView: 1,
          centeredSlides: true,
          spaceBetween: 0,
          initialSlide: 1,
          loop: true,
        },
        990: {
          enabled: false,
          slidesPerView: 2,
          spaceBetween: 0,
        }
      },
    });
  }

  window.addEventListener('DOMContentLoaded', () => {
    init();
  });

  return init;
})();

/**
 * Component: Pillars Module Eighteen Slider
 * ------------------------------------------------------------------------------
 * A Slider component.
 *
 */

// TODO: Update images

/**
 * Create a product related slider.
 */
theme.pillarsModuleEighteenSlider = (function() {
  /**
   * Initialise component.
   */
  function init() {
    console.log(`👸 Pillars Module Eighteen Slider: Loaded`)
    const sliders = document.querySelectorAll('.pillars-module-eighteen-swiper');
    
    sliders.forEach(element => {
      createSwiper(element);
    });
  }

  function createSwiper(element) {
    const swiper = new Swiper('.pillars-module-eighteen-swiper', {
      slidesPerView: 4.5,
      spaceBetween: 15,
      grabCursor: true,
      loop: true,
      autoplay: {
            delay: 3000, // Adjust the delay as needed (3000ms = 3 seconds)
            disableOnInteraction: false, // Optional: keeps autoplay running after user interactions
        },
      breakpoints: {
        300: {
          slidesPerView: 1,
        },
        641: {
          slidesPerView: 3.5,
        },
        989: {
	      slidesPerView: 4.5,
        }
      },
    });
  }

  window.addEventListener('DOMContentLoaded', () => {
    init();
  });

  return init;
})();

/**
 * Component: Module Nine Slider
 * ------------------------------------------------------------------------------
 * A Slider component.
 *
 */

// TODO: Update images

/**
 * Create a product related slider.
 */
theme.moduleNineSlider = (function() {
  /**
   * Initialise component.
   */
  function init() {
    console.log(`👸 Module Nine Slider: Loaded`)
    createSwiper();
  }

  function createSwiper() {
    const swiper = new Swiper('.module-nine-swiper', {
      slidesPerView: 1.5,
      spaceBetween: 0,
      grabCursor: false,
      breakpoints: {
        300: {
          enabled: true,
          slidesPerView: 1.5,
          centeredSlides: true,
          spaceBetween: 0,
          initialSlide: 1,
          loop: true,
        },
        990: {
          enabled: false,
          slidesPerView: 3,
          spaceBetween: 45,
        }
      },
    });
  }

  window.addEventListener('DOMContentLoaded', () => {
    init();
  });

  return init;
})();


/**
 * Component: Table respond on click mobile
 * ------------------------------------------------------------------------------
 * A table component.
 *
 */

/**
 * Create a responsive table.
 */
 theme.tableJS = (function() {
  /**
   * Initialise component.
   */
  function init() {
    console.log(`🤠 Table JS: Loaded`)
    addEventListeners();
  }

  function addEventListeners(){
    const tables = document.querySelectorAll('.table-js');

    tables.forEach(item => {
      checkTables(item);
    })

    document.addEventListener('click', function (event) {
      const element = event.target;

      if (element.matches('.table-js-arrow')) {
        element.parentNode.querySelector('.table-js__container').scrollLeft += 80;
      }
    });
  }

  function checkTables(item) {
    const table = item.querySelector('table')
    if (!table) { return }
    const cellCount = table.rows[0].cells.length;

    if (cellCount >= 4 ) {
      createTable(item);
    }
  }

  function createTable(item) {
    addActiveClass(item);
    createArrow(item);
    setTimeout(() => {
      showArrow(item)
    }, 300);

    window.addEventListener('resize', function(){
      showArrow(item);
    });
  }

  function addActiveClass(item) {
    item.classList.add('is-active');
  }

  function createArrow(item) {
    item.insertAdjacentHTML('beforeend', '<div class="table-js-arrow"></div><div class="swiper-button__underlay"></div>');
  }

  function showArrow(item) {
    const containerWidth = item.offsetWidth;
    const tableWidth = item.querySelector('table').offsetWidth;

    if (tableWidth > containerWidth) {
      item.querySelector('.table-js-arrow').classList.add('is-active');
      item.querySelector('.swiper-button__underlay').classList.add('is-active');
    } else {
      item.querySelector('.table-js-arrow').classList.remove('is-active');
      item.querySelector('.swiper-button__underlay').classList.remove('is-active');
    }
  }

  window.addEventListener('DOMContentLoaded', () => {
    init();
  });

  return init;
})();


// Karmoon End


// Menu navigation start

const toggleTag = document.querySelector("a.toggle-nav")
const navTag = document.querySelector(".nav-overlay")
const siteHeader = document.querySelector(".site-header")

// when i click the toggle tag, toggle a class of open on the main tag
// and if it's open, make the toggle tag say closed
// and not, make the toggle tag say open
toggleTag.addEventListener("click", function () {
  navTag.classList.toggle("open")
  siteHeader.classList.toggle("open")
  
  if (navTag.classList.contains("open")) {
    toggleTag.innerHTML = `<svg width="32px" height="32px" viewBox="0 0 32 32" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><g id="Spec" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd"><g id="Pillars-MobileMenuClose" transform="translate(0.000000, 1.000000)" fill-rule="nonzero"><path d="M29.0555095,7.00710643 C27.4124896,5.01743424 25.2506213,3.37379199 22.9158036,2.16268717 C20.2350869,0.778567382 17.2949461,0 14.5277547,0 C10.895816,0 7.86920048,0.692059895 5.62085748,2.16268717 C4.2372618,3.02776204 3.1130903,4.23886686 2.16186826,5.62298665 C0.691797844,7.95868879 0,10.9864508 0,14.7927803 C0,17.3014974 0.778272575,19.8102145 2.16186826,21.9729017 C3.9778376,25.0006637 6.91797844,27.5093808 10.2040182,28.9800081 C12.1064623,29.845083 14.1818558,30.2776204 16.2572493,30.2776204 C18.3326429,30.2776204 20.3215617,29.845083 22.2240057,28.9800081 C24.9047224,27.7689033 27.2395401,25.8657386 28.9690347,23.5300364 C30.8714788,21.0213193 31.9956503,17.9070498 31.9956503,14.7927803 C32.082125,11.9380332 30.8714788,9.25630109 29.0555095,7.00710643 Z M22.4834299,20.3292594 L21.2727837,21.5403642 L16.1707746,16.349915 L10.895816,21.6268717 L9.68516982,20.4157669 L14.9601284,15.1388102 L9.68516982,9.8618535 L10.895816,8.65074868 L16.1707746,13.9277054 L21.2727837,8.73725617 L22.4834299,9.94836099 L17.3814208,15.1388102 L22.4834299,20.3292594 Z" id="Shape" fill="#000000"></path><polygon id="Path" fill="#FCEEE0" points="22.4815864 9.9048755 21.2724906 8.69420009 16.1770155 13.882809 10.9088125 8.52124646 9.69971671 9.81839869 14.9679198 15.0934844 9.69971671 20.3685702 10.9088125 21.6657224 16.1770155 16.3041598 21.2724906 21.4927687 22.4815864 20.2820933 17.3861113 15.0934844"></polygon></g></g></svg>`
  } else {
    toggleTag.innerHTML = `<svg width="24px" height="17px" viewBox="0 0 24 17" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><g id="Symbols" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd"><g id="Header/Mobile/Cream" transform="translate(-331.000000, -32.000000)" stroke="#000000" stroke-width="2"><g id="Icon/Header/Logo-Copy-2" transform="translate(331.000000, 28.000000)"><polyline id="Stroke-1" points="-0.00012 5.4 8.9679284 5.4 23.99988 5.4"></polyline><line x1="-0.00012" y1="12.6" x2="23.99988" y2="12.6" id="Stroke-4"></line><line x1="-0.00012" y1="19.8" x2="23.99988" y2="19.8" id="Stroke-10"></line></g></g></g></svg>`
  }
})

// Menu navigation end

var links = document.links;
for (let i = 0, linksLength = links.length ; i < linksLength ; i++) {
  if (links[i].hostname !== window.location.hostname) {
    links[i].target = '_blank';
    links[i].relList.add('noreferrer', 'noopener');
  }
}